import script from "./profileTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./profileTabs.vue?vue&type=script&setup=true&lang=js"

import "./profileTabs.vue?vue&type=style&index=0&id=20b4303c&scoped=true&lang=css"
import "./profileTabs.vue?vue&type=style&index=1&id=20b4303c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20b4303c"]])

export default __exports__